import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { A } from '@adornis/base/env-info.js';

/** Per-client killswitch status from workbook import. */
@Entity()
export class PartnerSchedulingClientStatus extends MongoEntity {
  static override _class = 'PartnerSchedulingClientStatus';
  static override _collectionName = 'partner-scheduling-client-status';

  static override resolveID(entity: PartnerSchedulingClientStatus): string {
    return (entity._id ??= entity.clientKey ?? A.getGloballyUniqueID());
  }

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  override _id!: string;

  @Field(() => String)
  clientName: Maybe<string>;

  /** Normalized lookup key (matches ticket Project / workbook client name). */
  @Field(() => String)
  clientKey: Maybe<string>;

  @Field(() => Boolean, { default: () => false })
  enabled: Maybe<boolean>;
}
